import React from 'react';
import { FunctionField, TextField, useRecordContext } from 'react-admin';
import { AccessField, Datagrid, List } from '../ui';
import { BulkResetViewsButton } from './BulkDeleteUser';
import { useUserContext } from '../userContexts';
import { makeStyles } from '@material-ui/core';

const CustomLinkField = ({ source }) => {
    const record = useRecordContext();
    const [userContext] = useUserContext();
    if (record.id === userContext?.userDetails?.uuid) {
        return <span>{`${record.lastName}, ${record.firstName}`}</span>;
    }
    return (
        <a
            style={{
                textDecoration: 'none',
                color: '#114599',
                fontWeight: 'bold',
            }}
            href={`#/users/${record.id}`}
        >
            {' '}
            {`${record.lastName}, ${record.firstName}`}
        </a>
    );
};

const UsersList = props => {
    const [userContext] = useUserContext();
    const classes = useStyles(props);

    return (
        <>
            <List
                {...props}
                bulkActionButtons={<BulkResetViewsButton />}
                className={classes.list}
            >
                <Datagrid
                    {...props}
                    isRowSelectable={record =>
                        record.id !== userContext?.userDetails?.uuid
                    }
                >
                    <CustomLinkField source="name" label="Name" />

                    <TextField source="username" />
                    <TextField source="email" />
                    <TextField source="role" />
                    <AccessField
                        source="status"
                        translationKey="resources.users.status"
                    />
                    <FunctionField
                        label="days inactive"
                        render={record => {
                            if (record.lastLoginTs === 0) return 'N/A';
                            return (
                                Math.floor(new Date().getTime() / 86400000.0) -
                                Math.floor(record.lastLoginTs / 86400000.0)
                            );
                        }}
                    />
                </Datagrid>
            </List>
        </>
    );
};

const useStyles = makeStyles(theme => ({
    list: {
        '& .MuiCheckbox-root': {
            color: 'rgb(0, 0, 0)',
        },
    },
}));

export { UsersList };
